import { render, staticRenderFns } from "./groupTicketing.vue?vue&type=template&id=b85ff0e2&scoped=true"
import script from "./groupTicketing.vue?vue&type=script&lang=js"
export * from "./groupTicketing.vue?vue&type=script&lang=js"
import style0 from "./groupTicketing.vue?vue&type=style&index=0&id=b85ff0e2&prod&lang=css"
import style1 from "./groupTicketing.vue?vue&type=style&index=1&id=b85ff0e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85ff0e2",
  null
  
)

export default component.exports